module.exports = __webpack_public_path__ + "img/img_pokemon_excel.7c3e6093.jpg";